import { css } from '@emotion/react';
import { FilledInput, FormControl, FormLabel, Grid, Typography } from '@material-ui/core';
import Button from 'components/shared/Button/Button';
import {
	backToLoginCss,
	dialogTitleCss as BaseDialogTitleCss,
	forgotPasswordCss,
	forgotPasswordTextCss,
	fullWidthCss,
} from 'components/shared/Dialog/styles';
import { userApi } from 'lib/api/userApi';
import { i18n } from 'lib/i18n';
import { Dispatch, FC, SetStateAction, useState } from 'react';
import { Field as FinalField, Form } from 'react-final-form';
import { useColors } from 'hooks/useColors';
import { IColors } from 'types/colors'; // import { colors } from 'styles/theme';
import { ErrorText } from '../ErrorText';

const dialogTitleCss = (colors: IColors) => css`
	${BaseDialogTitleCss(colors)};
	&.MuiTypography-h5 {
		font-weight: 500;
		font-size: 2.2rem;
	}
`;

const userFormControlCss = css`
	.MuiFormLabel-root {
		padding: 8px 0px;
	}
	&.MuiFormControl-root {
		padding: 10px 0;
	}
`;

const loginInputCss = (colors: IColors) => css`
	background-color: ${colors.bg_background_primary};
	&.MuiInput-root {
		padding: 10px;
		margin: 0px;
	}
	.MuiFilledInput-input {
		height: 40px;
	}
`;

const loginInputFailedCss = (colors: IColors) => css`
	background-color: ${colors.bg_background_primary};
	&.MuiInput-root {
		padding: 10px;
		margin: 0px;
	}
	.MuiFilledInput-input {
		height: 40px;
	}
	border: 2px ${colors.bg_error} solid;
`;

const btnHeightCss = css`
	height: 50px;
	&.MuiButton-root {
		font-size: 1.6rem;
	}
`;

interface ForgotEmail {
	emailForgot: string;
}

interface ForgotPassFormProps {
	fromLoginPage?: boolean;
	setIsForgotPass: (values: boolean) => void;
	setSuccessPage: Dispatch<SetStateAction<boolean>>;
	setSuccessPageEmail: Dispatch<SetStateAction<string>>;
	setLoginTab: () => void;
}
// load forgot password dialog
const ForgotPasswordDialog: FC<ForgotPassFormProps> = props => {
	const { fromLoginPage, setSuccessPageEmail, setSuccessPage, setIsForgotPass, setLoginTab } = props;
	const { colors } = useColors();
	const [error, setError] = useState('');

	const onSubmitForgetPassword = (values: ForgotEmail) => {
		setSuccessPage(true);
		setSuccessPageEmail(values.emailForgot);
		// call api
		userApi.getForgotPassword(values.emailForgot).catch(error => {
			setError(error.message);
		});
	};

	return (
		<div css={forgotPasswordCss}>
			{!fromLoginPage && (
				<Grid
					container
					direction="column"
					justify="flex-end"
					alignItems="flex-start"
					css={backToLoginCss(colors)}
					onClick={() => {
						setIsForgotPass(false);
						setSuccessPage(false);
						setLoginTab();
					}}
				>
					<p>{i18n.loginDialog.backToLogin}</p>
				</Grid>
			)}
			<Grid container direction="column" justify="center" alignItems="center">
				<Grid item xs={12} css={fullWidthCss}>
					<Form
						onSubmit={onSubmitForgetPassword}
						render={({
							handleSubmit,
							//  form,
							// submitting,
							// pristine,
							// values,
						}) => (
							<form autoComplete="off" onSubmit={handleSubmit}>
								<Typography component="h1" variant="h5" css={dialogTitleCss(colors)}
									data-aid="ForgotPasswordDialog-resetTitle" id="login-dialog-title">
									{i18n.loginDialog.resetPasswordTitle}
								</Typography>
								<Typography component="h1" variant="h5" css={forgotPasswordTextCss(colors)}
									data-aid="ForgotPasswordDialog-resetText" id="login-dialog-title">
									{i18n.loginDialog.resetPasswordText}
								</Typography>

								{/* Email Address */}
								<FinalField name="emailForgot" displayEmpty>
									{({ input, meta }) => (
										<FormControl fullWidth css={userFormControlCss}>
											<FormLabel htmlFor="loginEmail">{i18n.loginDialog.email}</FormLabel>
											<FilledInput
												required
												disableUnderline
												placeholder={i18n.loginDialog.email}
												css={meta.error && meta.touched ? loginInputFailedCss(colors) : loginInputCss(colors)}
												type="email"
												autoComplete="email"
												{...input}
											/>
										</FormControl>
									)}
								</FinalField>
								<br />
								<br />
								<br />
								<Button data-aid="button-ForgotPasswordDialog-submit"
									type="submit" fullWidth variant="contained" color="secondary" css={btnHeightCss}>
									{i18n.loginDialog.requestPasswordReset.toLocaleUpperCase()}
								</Button>
								<ErrorText colors={colors} error={error} />
							</form>
						)}
					/>
				</Grid>
			</Grid>
		</div>
	);
};

export default ForgotPasswordDialog;
